import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { MemberShipOptions } from 'constants/index';
import SubMenu from 'components/common/SubMenu';
import FAQList from './components/FAQList';
import MembershipInfo from './components/MembershipInfo';

var MemberShipFAQService = function MemberShipFAQService() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SubMenu, {
      options: MemberShipOptions,
      selected: "FAQ"
    }), /*#__PURE__*/_jsx("div", {
      className: "cnts-wrap",
      children: /*#__PURE__*/_jsxs("div", {
        className: "membership-w faq-w",
        children: [/*#__PURE__*/_jsx(MembershipInfo, {}), /*#__PURE__*/_jsx(FAQList, {})]
      })
    })]
  });
};

export default MemberShipFAQService;